import React from 'react'

const ShippingOne = () => {
    return (
        <section className="shipping pt-80 pb-80" id="shipping">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item shipping-item-gradient flex-align gap-16 rounded-16 transition-2">
                            <span className="shipping-icon-certified w-56 h-56 flex-center rounded-circle bg-main-600 text-32 flex-shrink-0">
                                <i className="ph-fill ph-certificate" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">Produits Certifiés</h6>
                                <span className="text-sm text-heading">
                                    Qualité Garantie
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item shipping-item-gradient flex-align gap-16 rounded-16 transition-2">
                            <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                                <i className="ph-fill ph-car-profile" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">Livraison Rapide</h6>
                                <span className="text-sm text-heading">
                                    Partout au Maroc
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item shipping-item-gradient flex-align gap-16 rounded-16 transition-2">
                            <span className="shipping-icon-payment w-56 h-56 flex-center rounded-circle bg-main-600 text-32 flex-shrink-0">
                                <i className="ph-fill ph-credit-card" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">Paiement Flexible</h6>
                                <span className="text-sm text-heading">
                                    Espèce ou carte bancaire
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item shipping-item-gradient flex-align gap-16 rounded-16 transition-2">
                            <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                                <i className="ph-fill ph-chats" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">Conseil et support</h6>
                                <span className="text-sm text-heading">
                                    Assistance 24h/24
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default ShippingOne